var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 40.4961,
    height: 40.4961,
    rx: 20.248,
    stroke: "#800E13",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.499C20.0822 22.499 20.9997 23.1932 21.3457 24.166L21.4639 24.499H27.5V24.5H28C28.2759 24.5001 28.5 24.7241 28.5 25C28.4999 25.2758 28.2758 25.4999 28 25.5H21.4639L21.3457 25.833C20.9998 26.8056 20.0822 27.5 19 27.5C17.9181 27.4998 17.0013 26.8055 16.6553 25.833L16.5371 25.5H14.001C13.7251 25.4999 13.5011 25.2759 13.501 25C13.501 24.7241 13.7251 24.5001 14.001 24.5H16.5371L16.6553 24.167C17.0011 23.1935 17.9179 22.4992 19 22.499ZM23 14.5C24.0821 14.5002 24.999 15.1944 25.3447 16.167L25.4629 16.5H27.999C28.2406 16.5001 28.4425 16.6705 28.4893 16.8984L28.499 17C28.4984 17.2757 28.2752 17.4989 27.999 17.499H25.4629L25.3447 17.832C24.9986 18.8048 24.0816 19.4998 23 19.5C21.9178 19.5 21.0002 18.8056 20.6543 17.833L20.5361 17.5H14C13.7239 17.4999 13.5001 17.2765 13.5 17C13.5 16.7238 13.7235 16.5001 14 16.5H20.5361L20.6543 16.167C21.0003 15.1942 21.9178 14.5 23 14.5Z",
    stroke: "#800E13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/Filter_Icon.2a6eac53fade2e925ed3572a104a802e.svg";
export { ForwardRef as ReactComponent };